export const AnalyticsEventNames = [
  "view_home",
  "view_ticket_alerts",
  "view_restock_alerts",
  "view_availability",
  "view_availability_monitor",
  "view_pricing",
  "view_contact",
  "view_trust",
  "view_status",
  "view_blog",
  "view_blog_post",
  "view_how_it_works",
  "view_faq",
  "view_routes",
  "view_route_detail",
  "view_sold_out",
  "view_last_minute",
  "view_privacy",
  "view_terms",
  "qualified_visitor",
  "web_vital",
  "view_alert_setup",
  "builder_reached",
  "start_alert_setup",
  "alert_setup_ready",
  "alert_setup_abandoned",
  "alert_setup_guided",
  "click_create_alert",
  "click_contact",
  "login_google_start",
  "login_google_success",
  "login_google_error",
  "login_success",
  "login_email_link_complete_start",
  "login_email_link_error",
  "login_password_start",
  "login_password_error",
  "login_password_reset_start",
  "login_password_reset_success",
  "login_password_reset_error",
  "login_password_set_start",
  "login_password_set_success",
  "login_password_set_error",
  "register_password_start",
  "register_password_error",
  "checkout_section_viewed",
  "checkout_draft_prepared",
  "checkout_order_summary_edit_clicked",
  "checkout_payment_intent_prepared",
  "checkout_payment_intent_confirmed",
  "checkout_payment_confirmed",
  "checkout_payment_element_ready",
  "checkout_payment_details_started",
  "checkout_payment_details_complete",
  "checkout_pay_button_viewed",
  "checkout_pay_attempted",
  "checkout_payment_validation_failed",
  "checkout_pay_clicked",
  "checkout_confirm_payment_started",
  "checkout_confirm_payment_error",
  "checkout_confirm_payment_success",
  "checkout_activation_started",
  "checkout_activation_success",
  "checkout_activation_failed",
  "start_checkout",
  "checkout_redirect_created",
  "checkout_redirect_failed",
  "checkout_return_cancelled",
  "checkout_return_success",
  "checkout_error",
  "checkout_cancel",
  "checkout_source_feedback_submitted",
  "recovery_email_sent",
  "recovery_email_opened",
  "recovery_email_clicked",
  "recovery_landing_viewed",
  "recovery_checkout_resumed",
  "recovery_feedback_submitted",
  "contact_submit_success",
  "contact_submit_error",
  "purchase_success",
  "purchase_refunded",
  "create_alert_success",
  "alert_delivered",
  "monitor_check_summary",
  "official_booking_click",
  "alert_click",
  "self_report_success",
] as const;

export type AnalyticsEventName = (typeof AnalyticsEventNames)[number];

export const ANALYTICS_SCHEMA_VERSION = 2;
